import React from "react";
import { cn } from "utils";

/**
 * DashboardInfoField
 * Renders a compact label + value pair for use in the top info-row of dashboard pages.
 * Mirrors the name/status pattern used in the milestone dashboard.
 */
export const DashboardInfoField = ({ label, children, className }) => {
  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <span className="text-xs text-gray-500">{label}</span>
      <div className="font-medium text-sm">{children}</div>
    </div>
  );
};
